import React, { FC } from 'react';

import { Typography } from '@common/styles';

import { ProductCardProvider } from '../../context/ProductCardContext';
import { GetPDPRelatedItemList_pdp_related_item_list_ui_item_list_UxGoodsCardItem as RelatedItem } from '../../graphql/related-item-list_types.2';
import { ProductCard } from '../ProductCard';
import { mb2, mb4, Root, Title } from './RelatedItemList.styled';

interface Props {
  title: string;
  items: RelatedItem[];
}

export const RelatedItemList: FC<React.PropsWithChildren<Props>> = ({ title, items }) => {
  return (
    <Root>
      <Title className={Typography.BODY_18_SEMIBOLD}>{title}</Title>
      <ul>
        {items.map((value, index) => {
          return (
            <ProductCardProvider key={value.catalog_product_id ?? index} value={value}>
              <ProductCard.Template
                href={value.product_url ?? ''}
                image={<ProductCard.Image slots={[null, null, null, <ProductCard.ZigzinExpress size='sm' />]} />}
                storeName={<ProductCard.StoreName css={mb2} />}
                productName={<ProductCard.ProductName css={mb4} />}
                discount={<ProductCard.Discount css={mb2} />}
                price={<ProductCard.Price css={mb4} />}
                tags={<ProductCard.Tags css={mb4} />}
                review={<ProductCard.Review size='lg' />}
                endIcon={<ProductCard.Like size='md' iconType='list' />}
              />
            </ProductCardProvider>
          );
        })}
      </ul>
    </Root>
  );
};
